/**
 * @module features/clients/pages/ClientOnboardingPage
 * @description Dedicated full-page onboarding view for Client Organizations.
 * Wraps ClientFormPage in create mode.
 */
import * as React from "react";
import { ClientFormPage } from "./ClientFormPage";

export function ClientOnboardingPage() {
  return <ClientFormPage mode="create" />;
}
